import { Font } from '@react-pdf/renderer';

// Import font files
import SarabunRegular from '../assets/fonts/Sarabun-Regular.ttf';
import SarabunBold from '../assets/fonts/Sarabun-Bold.ttf';
import SarabunLight from '../assets/fonts/Sarabun-Light.ttf';
import SarabunMedium from '../assets/fonts/Sarabun-Medium.ttf';
import SarabunSemiBold from '../assets/fonts/Sarabun-SemiBold.ttf';

// Register Sarabun font family for Thai language support
export const registerThaiFonts = () => {
  Font.register({
    family: 'Sarabun',
    fonts: [
      { src: SarabunLight, fontWeight: 300 },
      { src: SarabunRegular, fontWeight: 400 },
      { src: SarabunMedium, fontWeight: 500 },
      { src: SarabunSemiBold, fontWeight: 600 },
      { src: SarabunBold, fontWeight: 700 },
    ],
  });
};

// Call registration immediately
registerThaiFonts();
